@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: 'PRODUCT_COMPOSITION',
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: productCompositionId(),
    recordId: productCompositionId(),
    type: `PRODUCT_COMPOSITION-${productCompositionId()}`,
    entityFileType: 'PRODUCT_COMPOSITION'
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
